var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedshift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 263.42 294.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#ff2121;}.cls-1{fill-opacity:0.4;}.cls-2{fill-opacity:0.52;}.cls-3{fill-opacity:0.77;}.cls-4{fill-opacity:0.83;}.cls-5{fill-opacity:0.93;}.cls-6{fill-opacity:0.9;}.cls-7{fill-opacity:0.78;}.cls-8{fill-opacity:0.63;}.cls-9{fill-opacity:0.86;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.42,73.66,131.72,0V73.66l65.85,36.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,73.66,131.72,0V73.66L65.87,110.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.57,110.49l-65.85,36.83V73.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.87,110.49l65.85,36.83V73.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.72,221V147.32l65.85,36.83L131.72,221Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M131.72,221V147.32L65.87,184.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M131.7,294.63V221L65.85,184.13,0,221Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M263.42,147.32V221l-65.85-36.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M0,147.32V221l65.85-36.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M263.4,147.32l-65.85-36.83L131.7,147.32l65.85,36.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0,147.32l65.86-36.81,65.86,36.81L65.87,184.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M263.42,73.66v73.66l-65.85-36.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M0,73.66v73.66l65.85-36.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.72,294.64V221l65.85-36.83L263.42,221l-131.7,73.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedshift);
export default __webpack_public_path__ + "static/media/redshift.2c6af24a7f099adce4178d745cbc70f9.svg";
export { ForwardRef as ReactComponent };